import React from 'react'

/** displays flickr spinner from https://loading.io (CC0 license)  */
const Loading = () => {
  return (
    <div className="flickr-spinner">
      <img src="/flickr-spinner.gif" alt="flickr spinner" />
    </div>
  )
}

export default Loading